import { render, staticRenderFns } from "./matchDetails.vue?vue&type=template&id=21fa868f&scoped=true&lang=pug&"
import script from "./matchDetails.vue?vue&type=script&lang=js&"
export * from "./matchDetails.vue?vue&type=script&lang=js&"
import style0 from "./matchDetails.vue?vue&type=style&index=0&id=21fa868f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa868f",
  null
  
)

export default component.exports